(function () {
  'use strict';

  const root = document.getElementById('frog-versus');
  if (!root) return;

  const WORKER = root.dataset.workerUrl;
  const CUSTOMER_ID = root.dataset.customerId || '';
  const LOGIN_URL = root.dataset.shopLoginUrl || '/account/login';

  const $ = (s) => root.querySelector(s);
  const els = {
    loading: $('[data-fv-loading]'),
    title: $('[data-fv-title]'),
    subtitle: $('[data-fv-subtitle]'),
    phase: $('[data-fv-phase]'),
    states: {
      empty: $('[data-fv-state="empty"]'),
      login: $('[data-fv-state="login"]'),
      voted: $('[data-fv-state="voted"]'),
      preround: $('[data-fv-state="preround"]'),
      bracket: $('[data-fv-state="bracket"]'),
      finished: $('[data-fv-state="finished"]')
    },
    grid: $('[data-fv-grid]'),
    selectedCount: $('[data-fv-selected-count]'),
    neededCount: $('[data-fv-needed-count]'),
    voteBtn: $('[data-fv-vote-btn]'),
    error: $('[data-fv-error]'),
    myPicks: $('[data-fv-my-picks]'),
    prizes: $('[data-fv-prizes]'),
    prizeWinnerLabel: $('[data-fv-prize-winner-label]'),
    prizePredictorLabel: $('[data-fv-prize-predictor-label]'),
    loginLink: $('[data-fv-login-link]'),
    bracketBody: $('[data-fv-bracket-body]'),
    finishedBody: $('[data-fv-finished-body]'),
    counter: $('[data-fv-live-counter]')
  };

  let tournament = null;
  let entries = [];
  let entryMap = new Map();
  let selected = new Set();
  let votesNeeded = 3;
  let predictions = {};
  let bracketCache = null;

  // ------------------ helpers ------------------
  function showState(name) {
    Object.values(els.states).forEach((el) => { if (el) el.hidden = true; });
    if (els.states[name]) els.states[name].hidden = false;
    if (els.loading) els.loading.hidden = true;
    // Sticky bar è fuori dagli states: la nascondo quando non siamo in pre-round
    const stickyBar = root.querySelector('[data-fv-sticky-bar]');
    if (stickyBar && name !== 'preround') stickyBar.setAttribute('hidden', '');
  }
  function showError(msg) { if (els.error) { els.error.textContent = msg; els.error.hidden = false; } }
  function clearError() { if (els.error) els.error.hidden = true; }
  function imgUrl(url, w) { if (!url) return ''; const sep = url.includes('?') ? '&' : '?'; return `${url}${sep}width=${w}`; }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  function formatCountdown(ts) {
    if (!ts) return null;
    const diff = ts - Date.now();
    if (diff <= 0) return 'in chiusura';
    const sec = Math.floor(diff / 1000);
    const days = Math.floor(sec / 86400);
    const hours = Math.floor((sec % 86400) / 3600);
    const mins = Math.floor((sec % 3600) / 60);
    if (days > 0) return `${days}g ${hours}h ${mins}m`;
    if (hours > 0) return `${hours}h ${mins}m`;
    if (mins > 0) return `${mins}m`;
    return 'meno di un minuto';
  }

  function startCountdownTicker() {
    if (window._fvTicker) return;
    window._fvTicker = setInterval(() => {
      root.querySelectorAll('[data-fv-countdown]').forEach((el) => {
        const ts = parseInt(el.dataset.fvCountdown);
        const txt = formatCountdown(ts);
        if (txt) el.textContent = txt;
      });
    }, 30000);
  }

  function pctPair(a, b) {
    const av = a || 0; const bv = b || 0; const total = av + bv;
    if (total === 0) return { a: '—', b: '—', total: 0 };
    const pa = Math.round((av / total) * 100);
    return { a: pa + '%', b: (100 - pa) + '%', total };
  }

  function formatEta(ts) {
    if (!ts) return null;
    const now = Date.now();
    const diffMs = ts - now;
    const d = new Date(ts);
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    if (diffMs < 0) return `chiusura imminente`;
    const hours = diffMs / (1000 * 60 * 60);
    if (hours < 1) return `entro un'ora (~${hh}:${mm})`;
    if (hours < 12) return `entro ~${Math.round(hours)} ore (verso le ${hh}:${mm})`;
    const today = new Date();
    const sameDay = d.toDateString() === today.toDateString();
    const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
    const isTomorrow = d.toDateString() === tomorrow.toDateString();
    if (sameDay) return `oggi alle ${hh}:${mm}`;
    if (isTomorrow) return `domani alle ${hh}:${mm}`;
    return `${d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' })} alle ${hh}:${mm}`;
  }

  // Modal zoom
  function openModal(imageSrc, title) {
    let modal = document.getElementById('frog-versus-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'frog-versus-modal';
      modal.className = 'frog-versus-modal';
      modal.innerHTML = `<div class="frog-versus-modal__overlay"></div><div class="frog-versus-modal__content"><button type="button" class="frog-versus-modal__close" aria-label="Chiudi">×</button><img class="frog-versus-modal__img" alt=""><div class="frog-versus-modal__title"></div></div>`;
      document.body.appendChild(modal);
      modal.querySelector('.frog-versus-modal__overlay').addEventListener('click', closeModal);
      modal.querySelector('.frog-versus-modal__close').addEventListener('click', closeModal);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });
    }
    modal.querySelector('.frog-versus-modal__img').src = imageSrc;
    modal.querySelector('.frog-versus-modal__img').alt = title || '';
    modal.querySelector('.frog-versus-modal__title').textContent = title || '';
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    const modal = document.getElementById('frog-versus-modal');
    if (modal) modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  // Delegated listener per icone zoom (event delegation sull root)
  root.addEventListener('click', (e) => {
    const zoomBtn = e.target.closest('[data-fv-zoom]');
    if (!zoomBtn) return;
    e.preventDefault();
    e.stopPropagation();
    openModal(zoomBtn.dataset.fvZoom, zoomBtn.dataset.fvZoomTitle || '');
  });

  function renderHeader() {
    if (!tournament) { els.title.textContent = 'FrogPick'; return; }
    els.title.textContent = tournament.title || 'Versus';
    els.subtitle.textContent = tournament.subtitle || '';
    const phaseLabel = { draft: 'In arrivo', preround: 'Pre-round aperto', bracket: 'Tabellone in corso', finished: 'Torneo concluso' }[tournament.status] || '';
    els.phase.textContent = phaseLabel;
    if (tournament.prize_winner_label) {
      els.prizeWinnerLabel.textContent = tournament.prize_winner_label;
      els.prizePredictorLabel.textContent = tournament.prize_predictor_label || '';
      els.prizes.hidden = false;
    }
    // Deadline banner
    const dlEl = root.querySelector('[data-fv-deadline]');
    const cdEl = root.querySelector('[data-fv-countdown]');
    const whenEl = root.querySelector('[data-fv-deadline-when]');
    if (dlEl && cdEl && whenEl) {
      if (tournament.phase_deadline) {
        cdEl.dataset.fvCountdown = tournament.phase_deadline;
        cdEl.textContent = formatCountdown(tournament.phase_deadline) || '';
        const d = new Date(tournament.phase_deadline);
        whenEl.textContent = `(${d.toLocaleDateString('it-IT', { day: '2-digit', month: 'long' })} alle ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')})`;
        dlEl.removeAttribute('hidden');
        startCountdownTicker();
      } else {
        dlEl.setAttribute('hidden', '');
      }
    }
  }

  async function refreshCounter() {
    if (!els.counter) return;
    try {
      const res = await fetch(`${WORKER}/versus/public/stats`);
      const s = await res.json();
      if (!s.active) { els.counter.hidden = true; return; }
      // Fallback se participants_total non ancora popolato (pre-deploy bump): usa il max dei counter di fase
      const total = Math.max(s.participants_total || 0, s.preround_voters || 0, s.predictors || 0);
      if (total <= 0) { els.counter.hidden = true; return; }
      const txt = total === 1
        ? `🟢 1 Frogger sta partecipando al torneo`
        : `🟢 ${total} Frogger stanno partecipando al torneo`;
      els.counter.textContent = txt;
      els.counter.hidden = false;
    } catch (e) {}
  }

  // ------------------ pre-round ------------------
  function renderGrid() {
    els.grid.innerHTML = '';
    entries.forEach((e) => {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'frog-versus__card';
      card.dataset.entryId = e.id;
      card.innerHTML = `
        <div class="frog-versus__card-imgwrap"><img class="frog-versus__card-img" src="${imgUrl(e.image, 1200)}" alt="${escapeHtml(e.title || '')}" loading="lazy" /></div>
        <div class="frog-versus__card-title">${escapeHtml(e.title || '')}</div>
        <div class="frog-versus__card-check">✓</div>
        <span class="frog-versus__zoom" data-fv-zoom="${imgUrl(e.image, 2000)}" data-fv-zoom-title="${escapeHtml(e.title || '')}" title="Ingrandisci">🔍</span>`;
      card.addEventListener('click', (ev) => { if (ev.target.closest('[data-fv-zoom]')) return; toggleSelect(card, e.id); });
      els.grid.appendChild(card);
    });
  }
  function toggleSelect(card, entryId) {
    clearError();
    if (selected.has(entryId)) { selected.delete(entryId); card.classList.remove('is-selected'); }
    else { if (selected.size >= votesNeeded) { showError(`Puoi scegliere solo ${votesNeeded} copertine.`); return; } selected.add(entryId); card.classList.add('is-selected'); }
    updateCounter();
  }
  function updateCounter() {
    els.selectedCount.textContent = selected.size; els.neededCount.textContent = votesNeeded;
    els.voteBtn.disabled = selected.size !== votesNeeded;
    const stickyBar = root.querySelector('[data-fv-sticky-bar]');
    if (stickyBar) {
      if (selected.size === votesNeeded) stickyBar.removeAttribute('hidden');
      else stickyBar.setAttribute('hidden', '');
    }
  }
  async function castPreroundVote() {
    if (!CUSTOMER_ID) { showState('login'); return; }
    if (selected.size !== votesNeeded) return;
    clearError(); els.voteBtn.disabled = true; els.voteBtn.textContent = 'Invio in corso…';
    try {
      const res = await fetch(`${WORKER}/versus/public/preround/vote`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customer_id: CUSTOMER_ID, entry_ids: Array.from(selected) }) });
      const data = await res.json();
      if (!res.ok) { if (data.already_voted) { await loadMyPreroundVote(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; } throw new Error(data.error || 'Errore'); }
      await loadMyPreroundVote();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) { showError(err.message); els.voteBtn.disabled = false; els.voteBtn.textContent = 'Conferma il voto'; }
  }
  async function loadMyPreroundVote() {
    if (!CUSTOMER_ID) return false;
    try {
      const res = await fetch(`${WORKER}/versus/public/preround/my-vote?customer_id=${encodeURIComponent(CUSTOMER_ID)}`);
      const data = await res.json();
      if (data.voted) {
        renderMyPicks(data.entry_ids || []);
        try {
          const sres = await fetch(`${WORKER}/versus/public/stats`);
          const s = await sres.json();
          const cEl = root.querySelector('[data-fv-voted-counter]');
          if (cEl && s.active) cEl.innerHTML = `🟢 <strong>${s.preround_voters}</strong> Frogger hanno già votato`;
        } catch (e) {}
        showState('voted');
        return true;
      }
    } catch (e) {}
    return false;
  }
  function renderMyPicks(ids) {
    if (!els.myPicks) return;
    els.myPicks.innerHTML = ids.map((id) => {
      const e = entryMap.get(id);
      if (!e) return '';
      return `<div class="frog-versus__my-pick">
        <div class="frog-versus__my-pick-imgwrap">
          <img class="frog-versus__my-pick-img" src="${imgUrl(e.image, 400)}" alt="${escapeHtml(e.title || '')}" loading="lazy" />
          <span class="frog-versus__zoom" data-fv-zoom="${imgUrl(e.image, 2000)}" data-fv-zoom-title="${escapeHtml(e.title || '')}" title="Ingrandisci">🔍</span>
        </div>
        <div class="frog-versus__my-pick-title">${escapeHtml(e.title || '')}</div>
      </div>`;
    }).join('');
  }

  // ------------------ bracket helpers ------------------
  async function loadBracket() {
    const url = CUSTOMER_ID
      ? `${WORKER}/versus/public/bracket?customer_id=${encodeURIComponent(CUSTOMER_ID)}`
      : `${WORKER}/versus/public/bracket`;
    const res = await fetch(url);
    const data = await res.json();
    if (!data.active || !data.bracket) return null;
    bracketCache = data;
    return data;
  }

  // ------------------ PREROUND RESULTS (classifica post-chiusura) ------------------
  let preroundResultsCache = null;
  async function loadPreroundResults() {
    if (preroundResultsCache !== null) return preroundResultsCache;
    try {
      const res = await fetch(`${WORKER}/versus/public/preround/results`);
      const data = await res.json();
      preroundResultsCache = (data && data.available) ? data : false;
      return preroundResultsCache;
    } catch (e) { preroundResultsCache = false; return false; }
  }
  function renderPreroundResults(data, opts) {
    if (!data || !data.results || !data.results.length) return '';
    const openByDefault = opts && opts.open;
    const passed = data.results.filter(r => r.qualified);
    const eliminated = data.results.filter(r => !r.qualified);
    const rowHtml = (r) => `
      <li class="frog-versus__pr-row ${r.qualified ? 'is-passed' : 'is-eliminated'}">
        <span class="frog-versus__pr-rank">${r.rank}°</span>
        <img class="frog-versus__pr-thumb" src="${imgUrl(r.image, 120)}" alt="${escapeHtml(r.title)}">
        <span class="frog-versus__pr-title">${escapeHtml(r.title)}</span>
        <span class="frog-versus__pr-bar"><span class="frog-versus__pr-bar-fill" style="width:${r.votes_pct}%;"></span></span>
        <span class="frog-versus__pr-pct">${r.votes_pct}%</span>
        <span class="frog-versus__pr-badge">${r.qualified ? '✓ Passata' : '✗ Eliminata'}</span>
      </li>`;
    return `
      <details class="frog-versus__preround-results"${openByDefault ? ' open' : ''}>
        <summary>📊 Classifica pre-round (${data.total_voters} votanti, ${data.qualified_count} su ${data.total_entries} passate)</summary>
        <div class="frog-versus__pr-body">
          <p class="frog-versus__small">% = quota di votanti che ha scelto la copertina tra le sue 3 preferite. Usala per scegliere meglio le tue predizioni.</p>
          <h4 class="frog-versus__pr-section-title">✅ Passate al tabellone (${passed.length})</h4>
          <ul class="frog-versus__pr-list">${passed.map(rowHtml).join('')}</ul>
          ${eliminated.length ? `
            <h4 class="frog-versus__pr-section-title frog-versus__pr-section-title--ko">❌ Eliminate (${eliminated.length})</h4>
            <ul class="frog-versus__pr-list">${eliminated.map(rowHtml).join('')}</ul>` : ''}
        </div>
      </details>`;
  }

  // ------------------ PREDICTION (schedina) ------------------
  async function loadMyPrediction() {
    if (!CUSTOMER_ID) return null;
    try {
      const res = await fetch(`${WORKER}/versus/public/prediction/my?customer_id=${encodeURIComponent(CUSTOMER_ID)}`);
      const data = await res.json();
      return data;
    } catch (e) { return null; }
  }

  function buildClientBracket(bracket) {
    // Costruisce il bracket lato client a partire dalle predizioni
    const out = JSON.parse(JSON.stringify(bracket));
    // Reset round 1+ entries (verranno popolati dalle predizioni)
    for (let ri = 1; ri < out.rounds.length; ri++) {
      for (const m of out.rounds[ri].matches) { m.entry_a = null; m.entry_b = null; }
    }
    // Propaga le predictions
    for (let ri = 0; ri < out.rounds.length - 1; ri++) {
      const round = out.rounds[ri];
      for (let mi = 0; mi < round.matches.length; mi++) {
        const m = round.matches[mi];
        const pred = predictions[m.id];
        if (!pred) continue;
        const winnerEntry = m.entry_a?.id === pred ? m.entry_a : (m.entry_b?.id === pred ? m.entry_b : null);
        if (!winnerEntry) continue;
        const next = out.rounds[ri + 1].matches[Math.floor(mi / 2)];
        if (mi % 2 === 0) next.entry_a = winnerEntry;
        else next.entry_b = winnerEntry;
      }
    }
    return out;
  }

  function pickPrediction(matchId, entryId) {
    predictions[matchId] = entryId;
    // Reset predizioni a cascata se invalide
    const m = matchId.match(/r(\d+)m(\d+)/);
    if (!m) { renderPredictionForm(); return; }
    const ri = parseInt(m[1]); const mi = parseInt(m[2]);
    const numRounds = bracketCache?.bracket?.rounds?.length || 0;
    let curRi = ri, curMi = mi;
    while (curRi < numRounds - 1) {
      const nextRi = curRi + 1;
      const nextMi = Math.floor(curMi / 2);
      const nextId = `r${nextRi}m${nextMi}`;
      const cb = buildClientBracket(bracketCache.bracket);
      const nextMatch = cb.rounds[nextRi]?.matches?.[nextMi];
      if (!nextMatch) break;
      if (predictions[nextId] && predictions[nextId] !== nextMatch.entry_a?.id && predictions[nextId] !== nextMatch.entry_b?.id) {
        delete predictions[nextId];
      }
      curRi = nextRi; curMi = nextMi;
    }
    renderPredictionForm();
  }

  async function renderPredictionForm() {
    if (!els.bracketBody) return;
    const bracket = bracketCache.bracket;
    const cb = buildClientBracket(bracket);
    const totalMatches = cb.rounds.reduce((s, r) => s + r.matches.length, 0);
    const filled = Object.keys(predictions).length;
    const points = bracket.round_points || [1, 2, 4, 8];
    const finalists = cb.rounds[0].matches.length * 2;
    let maxPts = 0;
    cb.rounds.forEach((r, i) => { maxPts += (points[i] || 0) * r.matches.length; });
    const prData = await loadPreroundResults();
    const prHtml = renderPreroundResults(prData, { open: true });
    const colsHtml = cb.rounds.map((round, ri) => {
      const matchesHtml = round.matches.map((m, mi) => {
        const myPick = predictions[m.id];
        const aReady = !!m.entry_a; const bReady = !!m.entry_b;
        return `<div class="frog-versus__pred-match ${myPick ? 'is-picked' : ''}">
          <div class="frog-versus__pred-label">Match ${mi + 1}</div>
          <button type="button" class="frog-versus__pred-side ${myPick === m.entry_a?.id ? 'is-chosen' : ''}" ${!aReady ? 'disabled' : ''} data-pick-match="${m.id}" data-pick-entry="${m.entry_a?.id || ''}">
            ${m.entry_a ? `<img src="${imgUrl(m.entry_a.image, 80)}"><span>${escapeHtml(m.entry_a.title)}</span><span class="frog-versus__pred-zoom" data-fv-zoom="${imgUrl(m.entry_a.image, 2000)}" data-fv-zoom-title="${escapeHtml(m.entry_a.title)}" title="Ingrandisci">🔍</span>` : '<span class="muted">In attesa</span>'}
          </button>
          <button type="button" class="frog-versus__pred-side ${myPick === m.entry_b?.id ? 'is-chosen' : ''}" ${!bReady ? 'disabled' : ''} data-pick-match="${m.id}" data-pick-entry="${m.entry_b?.id || ''}">
            ${m.entry_b ? `<img src="${imgUrl(m.entry_b.image, 80)}"><span>${escapeHtml(m.entry_b.title)}</span><span class="frog-versus__pred-zoom" data-fv-zoom="${imgUrl(m.entry_b.image, 2000)}" data-fv-zoom-title="${escapeHtml(m.entry_b.title)}" title="Ingrandisci">🔍</span>` : '<span class="muted">In attesa</span>'}
          </button>
        </div>`;
      }).join('');
      return `<div class="frog-versus__pred-col"><h4>${escapeHtml(round.label)}<br><small>${points[ri]}pt · ${round.matches.length} match</small></h4>${matchesHtml}</div>`;
    }).join('');
    const pointsRules = cb.rounds.map((r, i) => `<strong>${escapeHtml(r.label)}</strong>: ${points[i]} pt`).join(' · ');
    els.bracketBody.innerHTML = `
      <div class="frog-versus__pred-intro">
        <h2>Compila la tua schedina</h2>
        <p>Il pre-round è chiuso. Ecco le ${finalists} finaliste! <strong>Prevedi chi vincerà ogni match</strong> fino alla finale: più indovini, più sali in classifica predictor.</p>
        <div class="frog-versus__pred-rules">
          <div>${pointsRules} · MAX ${maxPts} pt</div>
          <div class="frog-versus__small">Omaggio al miglior predictor: <strong>${escapeHtml(tournament?.prize_predictor_label || '3 mesi PlayBold')}</strong> (in caso di pareggio, omaggio a tutti i pari-merito)</div>
        </div>
      </div>
      ${prHtml}
      <div class="frog-versus__pred-progress">Schedina ${filled}/${totalMatches}</div>
      <div class="frog-versus__pred-grid">${colsHtml}</div>
      <div class="frog-versus__actions">
        <button type="button" class="frog-versus__btn frog-versus__btn--primary" data-fv-save-pred ${filled !== totalMatches ? 'disabled' : ''}>Salva schedina</button>
      </div>
      <div class="frog-versus__error" data-fv-pred-error hidden></div>`;
    els.bracketBody.querySelectorAll('[data-pick-match]').forEach((btn) => {
      btn.addEventListener('click', (ev) => {
        if (ev.target.closest('[data-fv-zoom]')) return;
        const mid = btn.dataset.pickMatch;
        const eid = btn.dataset.pickEntry;
        if (eid) pickPrediction(mid, eid);
      });
    });
    const saveBtn = els.bracketBody.querySelector('[data-fv-save-pred]');
    if (saveBtn) saveBtn.addEventListener('click', savePrediction);
    showState('bracket');
  }

  async function savePrediction() {
    if (!CUSTOMER_ID) return;
    const errEl = els.bracketBody.querySelector('[data-fv-pred-error]');
    const saveBtn = els.bracketBody.querySelector('[data-fv-save-pred]');
    if (errEl) errEl.hidden = true;
    saveBtn.disabled = true; saveBtn.textContent = 'Salvataggio…';
    try {
      const res = await fetch(`${WORKER}/versus/public/prediction/save`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: CUSTOMER_ID, predictions })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Errore salvataggio');
      renderPredictionSaved();
    } catch (err) {
      if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
      saveBtn.disabled = false; saveBtn.textContent = 'Salva schedina';
    }
  }

  async function renderPredictionSaved() {
    const bracket = bracketCache.bracket;
    const cb = buildClientBracket(bracket);
    const finalRound = cb.rounds[cb.rounds.length - 1];
    const myFinalPick = predictions[finalRound.matches[0].id];
    const myFinalEntry = entryMap.get(myFinalPick);
    const colsHtml = cb.rounds.map((round) => {
      return `<div class="frog-versus__bcol"><h4>${escapeHtml(round.label)}</h4>${round.matches.map((m) => {
        const a = m.entry_a, b = m.entry_b;
        const myPick = predictions[m.id];
        const aChosen = myPick === a?.id;
        const bChosen = myPick === b?.id;
        return `<div class="frog-versus__bm">
          <div class="frog-versus__bm-row ${aChosen ? 'is-winner' : 'is-loser'}">${a ? `<img src="${imgUrl(a.image, 80)}"><span>${escapeHtml(a.title)}</span>` : '<span>—</span>'}</div>
          <div class="frog-versus__bm-row ${bChosen ? 'is-winner' : 'is-loser'}">${b ? `<img src="${imgUrl(b.image, 80)}"><span>${escapeHtml(b.title)}</span>` : '<span>—</span>'}</div>
        </div>`;
      }).join('')}</div>`;
    }).join('');
    const prData = await loadPreroundResults();
    const prHtml = renderPreroundResults(prData);
    els.bracketBody.innerHTML = `
      <div class="frog-versus__pred-saved">
        <h2>✓ Schedina inviata!</h2>
        <p>Aspetta che parta il primo match. Da quel momento la tua schedina sarà <strong>bloccata</strong> e accumulerà punti man mano che si chiudono i match.</p>
        ${myFinalEntry ? `<p>La tua scommessa per la vittoria: <strong>${escapeHtml(myFinalEntry.title)}</strong></p>` : ''}
      </div>
      ${prHtml}
      <h3 class="frog-versus__bracket-title">La tua schedina</h3>
      <div class="frog-versus__bracket">${colsHtml}</div>`;
    showState('bracket');
  }

  // ------------------ BRACKET ATTIVO (match + leaderboard) ------------------
  async function loadMyMatchVote(matchId) {
    if (!CUSTOMER_ID) return null;
    try {
      const res = await fetch(`${WORKER}/versus/public/match/my-vote?customer_id=${encodeURIComponent(CUSTOMER_ID)}`);
      const data = await res.json();
      if (data.voted && data.match_id === matchId) return data.entry_id;
    } catch (e) {}
    return null;
  }
  async function castMatchVote(entryId) {
    if (!CUSTOMER_ID) { showState('login'); return; }
    const entry = entryMap.get(entryId);
    const title = entry?.title || 'questa copertina';
    if (!confirm(`Confermi il voto per "${title}"?\n\nUna volta votato non potrai cambiare.`)) return;
    const savedY = window.scrollY;
    try {
      const res = await fetch(`${WORKER}/versus/public/match/vote`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customer_id: CUSTOMER_ID, entry_id: entryId }) });
      const data = await res.json();
      if (!res.ok && !data.already_voted) throw new Error(data.error || 'Errore voto');
      await loadBracket();
      await renderBracketActive();
      refreshCounter();
      window.scrollTo(0, savedY);
    } catch (err) { alert(err.message); }
  }

  async function renderBracketActive() {
    const data = bracketCache;
    const bracket = data.bracket;
    if (bracket.finished) { renderFinished(bracket); return; }
    const round = bracket.rounds[bracket.current_round];
    const match = round.matches[bracket.current_match];
    const myVote = await loadMyMatchVote(match.id);
    const a = match.entry_a, b = match.entry_b;
    const totalMatches = round.matches.length;
    const matchNum = bracket.current_match + 1;

    const myPred = await loadMyPrediction();
    const lb = await loadLeaderboard();
    const prData = await loadPreroundResults();
    const prHtml = renderPreroundResults(prData);

    const pcts = pctPair(match.votes_a, match.votes_b);
    const showPcts = !!myVote; // mostriamo le percentuali SOLO a chi ha già votato
    const aPctHtml = showPcts ? pcts.a : '🔒';
    const bPctHtml = showPcts ? pcts.b : '🔒';
    const matchHtml = `
      <div class="frog-versus__match">
        <div class="frog-versus__match-meta"><strong>${escapeHtml(round.label)}</strong> — Match ${matchNum} di ${totalMatches}</div>
        <div class="frog-versus__match-arena">
          <div class="frog-versus__match-sidewrap">
            <button type="button" class="frog-versus__match-side ${myVote === a?.id ? 'is-voted' : ''}" data-vote="${a?.id || ''}" ${!CUSTOMER_ID || myVote ? 'disabled' : ''}>
              <div class="frog-versus__match-imgwrap"><img src="${imgUrl(a?.image, 1200)}" alt="${escapeHtml(a?.title || '')}"></div>
              <div class="frog-versus__match-title">${escapeHtml(a?.title || 'TBD')}</div>
              <div class="frog-versus__match-votes" title="${showPcts ? '' : 'Visibile dopo il voto'}">${aPctHtml}</div>
            </button>
            ${a ? `<span class="frog-versus__zoom" data-fv-zoom="${imgUrl(a.image, 2000)}" data-fv-zoom-title="${escapeHtml(a.title)}" title="Ingrandisci">🔍</span>` : ''}
          </div>
          <div class="frog-versus__match-vs">VS</div>
          <div class="frog-versus__match-sidewrap">
            <button type="button" class="frog-versus__match-side ${myVote === b?.id ? 'is-voted' : ''}" data-vote="${b?.id || ''}" ${!CUSTOMER_ID || myVote ? 'disabled' : ''}>
              <div class="frog-versus__match-imgwrap"><img src="${imgUrl(b?.image, 1200)}" alt="${escapeHtml(b?.title || '')}"></div>
              <div class="frog-versus__match-title">${escapeHtml(b?.title || 'TBD')}</div>
              <div class="frog-versus__match-votes" title="${showPcts ? '' : 'Visibile dopo il voto'}">${bPctHtml}</div>
            </button>
            ${b ? `<span class="frog-versus__zoom" data-fv-zoom="${imgUrl(b.image, 2000)}" data-fv-zoom-title="${escapeHtml(b.title)}" title="Ingrandisci">🔍</span>` : ''}
          </div>
        </div>
        <div class="frog-versus__match-status">
          ${(() => {
            const closesAt = match.opens_at ? match.opens_at + 24 * 60 * 60 * 1000 : null;
            const eta = formatEta(closesAt);
            const closeText = eta ? `Chiusura stimata: <strong>${eta}</strong>` : '';
            if (!CUSTOMER_ID) return `<a class="frog-versus__btn frog-versus__btn--primary" href="${LOGIN_URL}">Accedi per votare</a><div class="frog-versus__small" style="margin-top:8px;">${closeText}</div>`;
            if (myVote) {
              const votedEntry = myVote === a?.id ? a : (myVote === b?.id ? b : null);
              const votedTitle = votedEntry ? escapeHtml(votedEntry.title) : '';
              return `<span class="frog-versus__voted-tag">✓ Hai votato ${votedTitle}</span><div class="frog-versus__small" style="margin-top:10px;">Prossimo match in arrivo dopo la chiusura di questo. ${closeText ? '<br>' + closeText : ''}<br>📌 Salva la pagina nei preferiti e torna a votare il prossimo!</div>`;
            }
            return `<span class="frog-versus__small">Clicca la copertina per cui vuoi votare.</span><div class="frog-versus__small" style="margin-top:6px;">${closeText}</div>`;
          })()}
        </div>
      </div>
      ${renderMyScore(myPred, lb)}
      ${renderMyBracket(myPred, bracket)}
      ${renderLeaderboard(lb)}
      ${prHtml}
      <h3 class="frog-versus__bracket-title">Tabellone ufficiale</h3>
      <p class="frog-versus__small" style="text-align:center;margin:0 0 16px;">Risultati reali del torneo (votati da tutti i Frogger).</p>
      <div class="frog-versus__bracket">${renderBracketGrid(bracket, !!myVote)}</div>`;
    els.bracketBody.innerHTML = matchHtml;
    showState('bracket');
    els.bracketBody.querySelectorAll('[data-vote]').forEach((btn) => { btn.addEventListener('click', () => { const id = btn.dataset.vote; if (id) castMatchVote(id); }); });
  }

  function renderMyBracket(myPred, bracket) {
    if (!myPred || !myPred.saved || !myPred.predictions) return '';
    const preds = myPred.predictions;
    const points = bracket.round_points || [1, 2, 4, 8];
    let totalCorrect = 0, totalWrong = 0, totalPending = 0, totalDead = 0;

    const roundsHtml = bracket.rounds.map((round, ri) => {
      const rowsHtml = round.matches.map((m, mi) => {
        const myPickId = preds[m.id];
        if (!myPickId) return '';
        const e = entryMap.get(myPickId);
        const realWinner = m.winner;
        const matchHasEntries = !!(m.entry_a && m.entry_b);
        const matchHasMyPick = (m.entry_a?.id === myPickId) || (m.entry_b?.id === myPickId);

        let status = 'pending';
        let statusHtml = `<span class="frog-versus__pickrow-badge is-pending">⏳ Match da giocare · vale ${points[ri]} pt</span>`;
        let actualWinnerHtml = '';
        if (realWinner) {
          if (realWinner === myPickId) {
            status = 'correct';
            statusHtml = `<span class="frog-versus__pickrow-badge is-correct">✓ Indovinata! +${points[ri]} pt</span>`;
            totalCorrect++;
          } else {
            status = 'wrong';
            const realE = entryMap.get(realWinner);
            statusHtml = `<span class="frog-versus__pickrow-badge is-wrong">✗ Sbagliata · 0 pt</span>`;
            actualWinnerHtml = realE ? `<div class="frog-versus__pickrow-actual">Il vincitore è stato: <strong>${escapeHtml(realE.title)}</strong></div>` : '';
            totalWrong++;
          }
        } else if (matchHasEntries && !matchHasMyPick) {
          status = 'dead';
          statusHtml = `<span class="frog-versus__pickrow-badge is-dead">💀 Fuori gioco</span>`;
          actualWinnerHtml = `<div class="frog-versus__pickrow-actual">La tua copertina ha già perso un round precedente, non sarà presente in questo match.</div>`;
          totalDead++;
        } else {
          totalPending++;
        }

        return `<div class="frog-versus__pickrow-item is-${status}">
          <div class="frog-versus__pickrow-num">Match ${mi + 1}</div>
          <div class="frog-versus__pickrow-pick">
            <div class="frog-versus__pickrow-thumbwrap">
              <img src="${imgUrl(e?.image, 200)}" alt="" class="frog-versus__pickrow-thumb">
              ${e?.image ? `<span class="frog-versus__pred-zoom frog-versus__pred-zoom--small" data-fv-zoom="${imgUrl(e.image, 2000)}" data-fv-zoom-title="${escapeHtml(e?.title || '')}" title="Ingrandisci">🔍</span>` : ''}
            </div>
            <div class="frog-versus__pickrow-text">
              <div class="frog-versus__pickrow-mychoice"><span class="lbl">La tua scelta:</span> <strong>${escapeHtml(e?.title || '?')}</strong></div>
              ${statusHtml}
              ${actualWinnerHtml}
            </div>
          </div>
        </div>`;
      }).join('');
      return `<div class="frog-versus__pickround">
        <div class="frog-versus__pickround-head">
          <span class="frog-versus__pickround-name">${escapeHtml(round.label)}</span>
          <span class="frog-versus__pickround-pts">${points[ri]} pt per match indovinato</span>
        </div>
        ${rowsHtml}
      </div>`;
    }).join('');

    const summary = `<div class="frog-versus__pickstats">
      <span class="ok">${totalCorrect} indovinati</span>
      <span class="ko">${totalWrong} sbagliati</span>
      ${totalDead > 0 ? `<span class="dead">${totalDead} fuori gioco</span>` : ''}
      <span class="pen">${totalPending} in attesa</span>
    </div>`;

    return `<div class="frog-versus__myschedina">
      <div class="frog-versus__myschedina-head">
        <h3>📋 Le tue scelte (schedina)</h3>
        ${summary}
      </div>
      <p class="frog-versus__small" style="margin:0 0 16px;">Per ogni match del torneo, ecco cosa hai previsto. Più il torneo avanza, più i tuoi punti si aggiornano.</p>
      ${roundsHtml}
    </div>`;
  }

  function renderMyScore(myPred, lb) {
    if (!myPred || !myPred.saved) {
      return `<div class="frog-versus__myscore frog-versus__myscore--empty">⚠️ Non hai compilato la schedina prima dell'avvio del bracket. Non potrai concorrere all'omaggio "miglior predictor".</div>`;
    }
    const pos = lb && lb.my_position ? lb.my_position : '—';
    const total = lb ? lb.total : '—';
    const bd = myPred.breakdown || {};
    const rounds = bracketCache?.bracket?.rounds || [];
    const bdHtml = rounds.map(r => `<span>${escapeHtml(r.label)} ${bd[r.name] || 0}</span>`).join('');
    return `<div class="frog-versus__myscore">
      <div class="frog-versus__myscore-pts"><span class="big">${myPred.score}</span><small>punti</small></div>
      <div class="frog-versus__myscore-pos">Posizione: <strong>${pos}°</strong> su ${total}</div>
      <div class="frog-versus__myscore-bd">${bdHtml}</div>
    </div>`;
  }

  async function loadLeaderboard() {
    try {
      const url = CUSTOMER_ID ? `${WORKER}/versus/public/prediction/leaderboard?customer_id=${encodeURIComponent(CUSTOMER_ID)}` : `${WORKER}/versus/public/prediction/leaderboard`;
      const res = await fetch(url);
      return await res.json();
    } catch (e) { return null; }
  }

  function renderLeaderboard(lb) {
    if (!lb || !lb.top || !lb.top.length) return '';
    const rows = lb.top.map((x) => `<li class="${x.is_me ? 'is-me' : ''}"><span class="pos">${x.position}°</span><span class="name">${escapeHtml(x.display_name)}${x.is_me ? ' (tu)' : ''}</span><span class="pts">${x.points} pt</span></li>`).join('');
    return `<div class="frog-versus__leaderboard"><h3>🏅 Classifica predictor</h3><ol>${rows}</ol>${lb.total > 10 ? `<p class="frog-versus__small">Top 10 mostrato — totale ${lb.total} predictor</p>` : ''}</div>`;
  }

  function renderBracketGrid(bracket, hasVotedCurrent = true) {
    return bracket.rounds.map((round, ri) => {
      const matches = round.matches.map((m, mi) => {
        const isPast = !!m.winner;
        const isCurrent = !m.winner && ri === bracket.current_round && mi === bracket.current_match && !bracket.finished;
        const a = m.entry_a, b = m.entry_b;
        const aWin = m.winner && a && m.winner === a.id;
        const bWin = m.winner && b && m.winner === b.id;
        const pcts = pctPair(m.votes_a, m.votes_b);
        const aZoom = a ? `<img src="${imgUrl(a.image, 200)}" data-fv-zoom="${imgUrl(a.image, 2000)}" data-fv-zoom-title="${escapeHtml(a.title)}" style="cursor:zoom-in;" title="Clicca per ingrandire"><span>${escapeHtml(a.title)}</span>` : '<div class="frog-versus__bm-blank"></div><span>TBD</span>';
        const bZoom = b ? `<img src="${imgUrl(b.image, 200)}" data-fv-zoom="${imgUrl(b.image, 2000)}" data-fv-zoom-title="${escapeHtml(b.title)}" style="cursor:zoom-in;" title="Clicca per ingrandire"><span>${escapeHtml(b.title)}</span>` : '<div class="frog-versus__bm-blank"></div><span>TBD</span>';
        // Match attivo: mostro % solo se il cliente ha votato. Match passati: sempre.
        const showPct = isPast || (isCurrent && hasVotedCurrent);
        const aPct = isCurrent && !hasVotedCurrent ? '<b title="Visibile dopo il voto">🔒</b>' : (showPct ? `<b>${pcts.a}</b>` : '');
        const bPct = isCurrent && !hasVotedCurrent ? '<b title="Visibile dopo il voto">🔒</b>' : (showPct ? `<b>${pcts.b}</b>` : '');
        return `<div class="frog-versus__bm ${isCurrent ? 'is-current' : ''} ${isPast ? 'is-past' : ''}">
          <div class="frog-versus__bm-row ${aWin ? 'is-winner' : ''} ${m.winner && !aWin ? 'is-loser' : ''}">${aZoom}${aPct}</div>
          <div class="frog-versus__bm-row ${bWin ? 'is-winner' : ''} ${m.winner && !bWin ? 'is-loser' : ''}">${bZoom}${bPct}</div>
        </div>`;
      }).join('');
      return `<div class="frog-versus__bcol"><h4>${escapeHtml(round.label)}</h4>${matches}</div>`;
    }).join('');
  }

  // ------------------ FINISHED ------------------
  async function renderFinished(bracket) {
    const finalRound = bracket.rounds[bracket.rounds.length - 1];
    const finalMatch = finalRound.matches[0];
    const winner = finalMatch && finalMatch.winner ? (finalMatch.entry_a?.id === finalMatch.winner ? finalMatch.entry_a : finalMatch.entry_b) : null;
    const loser = finalMatch && finalMatch.winner ? (finalMatch.entry_a?.id === finalMatch.winner ? finalMatch.entry_b : finalMatch.entry_a) : null;
    const lb = await loadLeaderboard();
    const lbHtml = renderLeaderboard(lb);
    if (!winner) { els.finishedBody.innerHTML = '<h2>Torneo concluso</h2>' + lbHtml; showState('finished'); return; }
    const pcts = pctPair(finalMatch.votes_a, finalMatch.votes_b);
    const winnerIsA = finalMatch.entry_a?.id === finalMatch.winner;
    const winnerPct = winnerIsA ? pcts.a : pcts.b;
    const loserPct = winnerIsA ? pcts.b : pcts.a;
    let finalScoreHtml;
    if (pcts.total > 0) {
      finalScoreHtml = `<div class="frog-versus__champion-score">Vinta con <strong>${winnerPct}</strong> dei voti${loser ? ` contro il <strong>${loserPct}</strong> di ${escapeHtml(loser.title)}` : ''}</div>`;
    } else {
      finalScoreHtml = `<div class="frog-versus__champion-score">Vincitore designato per default <small>(nessun voto sul match finale)</small></div>`;
    }
    els.finishedBody.innerHTML = `
      <div class="frog-versus__champion">
        <div class="frog-versus__champion-trophy">🏆</div>
        <div class="frog-versus__champion-imgwrap">
          <img src="${imgUrl(winner.image, 1200)}" alt="">
          <span class="frog-versus__zoom" data-fv-zoom="${imgUrl(winner.image, 2000)}" data-fv-zoom-title="${escapeHtml(winner.title)}" title="Ingrandisci">🔍</span>
        </div>
        <h2>${escapeHtml(winner.title)}</h2>
        <p>è la copertina più bella, eletta dai Frogger.</p>
        ${finalScoreHtml}
      </div>
      ${lbHtml}
      <h3 class="frog-versus__bracket-title">Tabellone finale</h3>
      <p class="frog-versus__small" style="text-align:center;margin:0 0 16px;">Tutti i match con la percentuale dei voti finali.</p>
      <div class="frog-versus__bracket">${renderBracketGrid(bracket)}</div>`;
    showState('finished');
  }

  // ------------------ INIT ------------------
  async function init() {
    if (els.loginLink) els.loginLink.href = LOGIN_URL;
    try {
      const res = await fetch(`${WORKER}/versus/public/entries`);
      const data = await res.json();
      if (!data.active) { renderHeader(); showState('empty'); return; }
      tournament = data.tournament; entries = data.entries || [];
      entryMap = new Map(entries.map((e) => [e.id, e]));
      votesNeeded = tournament.preround_votes_per_user || 3;
      renderHeader(); refreshCounter();

      if (tournament.status === 'preround') {
        if (!CUSTOMER_ID) { showState('login'); return; }
        if (await loadMyPreroundVote()) return;
        renderGrid(); updateCounter(); showState('preround'); return;
      }
      if (tournament.status === 'bracket') {
        const bd = await loadBracket();
        if (!bd || !bd.bracket) { showState('empty'); return; }
        if (!bd.bracket.predictions_locked) {
          // Fase schedina aperta — richiede login
          if (!CUSTOMER_ID) { showState('login'); return; }
          const my = await loadMyPrediction();
          if (my && my.saved) { predictions = my.predictions || {}; renderPredictionSaved(); return; }
          predictions = {}; renderPredictionForm(); return;
        }
        // Bracket attivo — anche non loggati possono vedere il match (con bottoni disabilitati)
        await renderBracketActive(); return;
      }
      if (tournament.status === 'finished') {
        const bd = await loadBracket();
        if (bd && bd.bracket) { renderFinished(bd.bracket); return; }
        showState('finished'); return;
      }
      showState('empty');
    } catch (err) {
      console.error(err); showError('Errore nel caricamento. Riprova fra poco.');
      if (els.loading) els.loading.hidden = true;
    }
  }

  if (els.voteBtn) els.voteBtn.addEventListener('click', castPreroundVote);
  const stickyVoteBtn = root.querySelector('[data-fv-sticky-vote]');
  if (stickyVoteBtn) stickyVoteBtn.addEventListener('click', castPreroundVote);
  init();
})();
